module.exports = __webpack_public_path__ + "static/media/023.c54af036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/023.jpg
// module id = 530
// module chunks = 0